import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import storyCardFragment from '@schema/story-card'
import GolfCoursesPage from './index'

const QUERY = gql`
query CoursesLanding($preview: Boolean)  {
  coursesLandingCollection(limit: 1, preview: $preview) {
    items {
      heroHeadline
      metaTitle
      metaDescription
      metaImage {
        url
      }
      heroImage {
        url
      }
      featuredCourseId
      featuredCourseEyebrow
      featuredCourseImage {
        url
      }
      destinationsHeadline
      featuredStory {
        ${storyCardFragment}
      }
      storiesCollection {
        items {
          ${storyCardFragment}
        }
      }
    }
  }
}
`

export { QUERY as COURSES_LANDING_QUERY }

export default function GolfCoursesPageWithData(props) {
  const { query, ssrData } = props

  // If SSR data is provided, render directly
  if (ssrData != null) {
    return <GolfCoursesPage {...props} {...ssrData} />
  }

  // Fallback to client-side fetching
  return (
    <Query query={QUERY} variables={query}>
      {({
        loading, error, data,
      }) => {
        if (error) {
          return <Error error={error} displayErrorType="page" />
        }
        if (loading) return <LinearProgress color="secondary" />
        const response = data
          && data.coursesLandingCollection
          && data.coursesLandingCollection.items
          && data.coursesLandingCollection.items[0]
        return (
          <GolfCoursesPage {...props} {...response} />
        )
      }}
    </Query>
  )
}

GolfCoursesPageWithData.propTypes = {
  query: PropTypes.object,
  ssrData: PropTypes.object,
}
